import React from "react";
import { Container } from "react-bootstrap";
import Fade from "react-reveal/Fade";
import "./Roadmap.css";

const milestones = [
  {
    phase: "01",
    status: "Complete",
    title: "Lottery Pilot on Testnet",
    desc:
      "Lottery pilot with core features launched on testnet for the community to try and give feedback. This pilot was semi automated.",
  },
  {
    phase: "02",
    status: "Live",
    title: "Lottery on Mainnet",
    desc:
      "Lottery module launched on mainnet with fully functional core lottery features, using the network governance token as currency.",
  },
  {
    phase: "03",
    status: "In progress",
    title: "Tokenization",
    desc:
      "Platform token (BET) becomes a lottery currency, backed by swapping and liquidity pool modules. Platform assets will also be available as NFTs.",
  },
  {
    phase: "04",
    status: "Live",
    title: "LotteryHub",
    desc:
      "Different variations and types of lotteries: single player draw, multiplayer draw, and scheduled automated draw.",
  },
  {
    phase: "05",
    status: "Planned",
    title: "DeFi Ecosystem",
    desc:
      "BET connects to existing DeFi platforms for community investment. Earn rewards and passive income through BET as well as NFTs.",
  },
  {
    phase: "06",
    status: "Planned",
    title: "Cryptogames",
    desc:
      "Followed by lottery, various cryptogames will be launched, including gambling and casino games.",
  },
];

const Roadmap = () => {
  return (
    <section className="roadmap home-roadmap">
      <Container className="home-container">
        <div className="home-roadmap-panel">
          <Fade bottom>
            <div className="home-roadmap-head">
              <p className="home-kicker">Product journey</p>
              <h2 className="home-section-title">Roadmap</h2>
              <p className="home-section-copy">
                From testnet pilots to a full AutoBET ecosystem — each phase
                expands what creators and players can do on-chain.
              </p>
            </div>
          </Fade>

          <ol className="home-timeline">
            {milestones.map((item, index) => (
              <li
                key={item.phase}
                className={`home-timeline-item home-timeline-${item.status
                  .toLowerCase()
                  .replace(" ", "-")}`}
              >
                <Fade bottom delay={index * 80}>
                  <article className="home-timeline-card">
                    <div className="home-timeline-meta">
                      <span className="home-timeline-phase">
                        Phase {item.phase}
                      </span>
                      <span className="home-timeline-status">{item.status}</span>
                    </div>
                    <h3 className="home-timeline-title">{item.title}</h3>
                    <p className="home-timeline-desc">{item.desc}</p>
                  </article>
                </Fade>
                <span className="home-timeline-marker" aria-hidden="true">
                  {item.phase}
                </span>
              </li>
            ))}
          </ol>
        </div>
      </Container>
    </section>
  );
};

export default Roadmap;
